import { Link as GatsbyLink } from "gatsby"
import React from "react"

const Link = ({ children, to, activeClassName, partiallyActive, ...other }) => {
  const internal = /^\/(?!\/)/.test(to)
  const file = /\.[0-9a-z]+$/i.test(to)

  // Add trailing slash to internal links if not present and not a file
  let toWithTrailingSlash = to
  if (internal && !file && !to.endsWith("/")) {
    toWithTrailingSlash = `${to}/`
  }

  if (internal) {
    if (file) {
      return (
        <a href={to} {...other}>
          {children}
        </a>
      )
    }
    // Use modified 'to' with trailing slash
    return (
      <GatsbyLink
        to={toWithTrailingSlash}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </GatsbyLink>
    )
  }
  return (
    <a href={to} {...other}>
      {children}
    </a>
  )
}

export default Link
